export const LOAD_CENTER_USER_REQUESTED = '@terminal-services/centerUsers/LOAD_CENTER_USER_REQUESTED';



// WEBPACK FOOTER //
// ./src/modules/centerUsers/actionTypes.js